import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080/api',
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 — redirect to login
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// ===== AUTH =====
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  verifyEmail: (token) => api.post(`/auth/verify-email?token=${token}`),
  forgotPassword: (email) => api.post(`/auth/forgot-password?email=${email}`),
  resetPassword: (token, newPassword) =>
    api.post(`/auth/reset-password?token=${token}&newPassword=${newPassword}`),
};

// ===== CAMPAIGNS =====
export const campaignAPI = {
  getAll: (page = 0, size = 9) => api.get(`/campaigns?page=${page}&size=${size}`),
  getById: (id) => api.get(`/campaigns/${id}`),
  create: (data) => api.post('/campaigns', data),
  update: (id, data) => api.put(`/campaigns/${id}`, data),
  close: (id) => api.delete(`/campaigns/${id}`),
  uploadKyc: (id, file) => {
    const form = new FormData();
    form.append('document', file);
    return api.post(`/campaigns/${id}/kyc`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  getMyCampaigns: (page = 0) => api.get(`/campaigns/my-campaigns?page=${page}`),
};

// ===== DONATIONS =====
export const donationAPI = {
  initiateStripe: (data) => api.post('/donations/stripe/initiate', data),
  initiateRazorpay: (data) => api.post('/donations/razorpay/initiate', data),
  verifyRazorpay: (orderId, paymentId, signature) =>
    api.post(`/donations/razorpay/verify?razorpayOrderId=${orderId}&razorpayPaymentId=${paymentId}&razorpaySignature=${signature}`),
  getCampaignDonations: (campaignId, page = 0) =>
    api.get(`/donations/campaign/${campaignId}?page=${page}`),
};

export default api;
